import { Button, Card, CardActions, CardContent, styled, Typography } from '@ethings/ui-toolkit';
// eslint-disable-next-line camelcase
import { SxProps, unstable_styleFunctionSx as unstableStyleFunctionSx } from '@mui/system';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useResponsiveText } from '../../hooks';

interface Props {
  'data-testid'?: string;
  display: string;
  elevation?: number;
  href: string;
  sx?: SxProps;
}

interface StyledCardProps {
  sx?: SxProps;
}

const StyledCard = styled(Card)<StyledCardProps>(({ sx, theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: theme.spacing(31.25),
  ...(unstableStyleFunctionSx({ sx, theme } as never) as Record<string, unknown>),
}));

export const SearchResultsCard: FC<Props> = ({
  display,
  elevation,
  href,
  sx,
  ...props
}) => {
  const { t } = useTranslation(['common']);

  const h5Styles = useResponsiveText('1.5rem', display.length, {
    minFontSize: '1.25rem',
    maxFontSize: '1.5rem',
    textLengthThreshold: 25,
  });

  return (
    <StyledCard
      data-testid={props['data-testid']}
      elevation={elevation}
      sx={sx}
    >
      <CardContent style={{ flexGrow: 1, marginBottom: 2 }}>
        <Typography
          display="-webkit-box"
          fontWeight={500}
          overflow="hidden"
          mb={2}
          variant="h5"
          style={{
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            fontSize: h5Styles.fontSize,
            lineHeight: h5Styles.lineHeight,
            wordBreak: h5Styles.wordBreak,
            whiteSpace: h5Styles.whiteSpace,
            textOverflow: h5Styles.textOverflow,
          }}
        >
          {display}
        </Typography>
      </CardContent>
      <CardActions style={{ height: '20%', justifyContent: 'flex-end', paddingTop: 0 }}>
        <Button component="a" href={href} data-testid="search-results-view-button">
          {t('common:common.action.view')}
        </Button>
      </CardActions>
    </StyledCard >
  );
};
